export const environment = {
    version: '1.0.0',
    tenantId: '',
    production: true,
    urlApi: 'https://portal-bff-prd.silgov.io',
    urlAuth: 'https://auth-prd.silgov.io',
    urlParticipant: 'https://app.silgov.com.br',
    // Cadastro de cidadão (visitante, spec 048 do app-frontend): desligado até o fim do deploy de todos os repositórios.
    visitorSignupEnabled: true
}
